import { css } from '@/styled-system/css';

export const menuListStyles = css.raw({
  listStyle: 'none',
});
